/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosCard as CosmosCardRoot } from "./CosmosCard";
import { CosmosCardContent } from "./CosmosCardContent";
import { CosmosCardLink } from "./CosmosCardLink";
import { CosmosCardThumbnail } from "./CosmosCardThumbnail";
import { CosmosCardThumbnailOverlay } from "./CosmosCardThumbnailOverlay";

import type { CosmosCardProps } from "./CosmosCard";
import type { CosmosCardContentProps } from "./CosmosCardContent";
import type { CosmosCardLinkProps } from "./CosmosCardLink";
import type { CosmosCardThumbnailProps } from "./CosmosCardThumbnail";
import type { CosmosCardThumbnailOverlayProps } from "./CosmosCardThumbnailOverlay";

const CosmosCard: typeof CosmosCardRoot & {
	Content: typeof CosmosCardContent;
	Link: typeof CosmosCardLink;
	Thumbnail: typeof CosmosCardThumbnail;
	ThumbnailOverlay: typeof CosmosCardThumbnailOverlay;
} = Object.assign(CosmosCardRoot, {
	Content: CosmosCardContent,
	Link: CosmosCardLink,
	Thumbnail: CosmosCardThumbnail,
	ThumbnailOverlay: CosmosCardThumbnailOverlay,
});

export { CosmosCard, CosmosCardContent, CosmosCardLink, CosmosCardThumbnail, CosmosCardThumbnailOverlay };

export type {
	CosmosCardProps,
	CosmosCardContentProps,
	CosmosCardLinkProps,
	CosmosCardThumbnailProps,
	CosmosCardThumbnailOverlayProps,
};
